
import * as React from 'react';
import autobind from 'autobind-decorator';
import store from '__common/store';
import SVG from 'react-inlinesvg';
import { Button } from '__common/components/Button';
import { connect } from 'react-redux';
import { LOAD_PANELS_FROM_HISTORY, UNDO_HISTORY } from '__editor/panelsEditor/actions';
import { DEBUG } from 'debug';

type UndoProps = onlyDispatchComponentState & {
  history: historyState,
};

class Undo extends React.Component<UndoProps, {}> {
  @autobind
  action() {
    const { dispatch, history } = this.props;

    if (!DEBUG.enablePanelsUndo || !history.canUndo) {
      return;
    }

    dispatch(UNDO_HISTORY());
    const { history: updatedHistory, settings: { rowSpacing, columnSpacing }, background: { metersPerPixel } } = store.getState();
    const panels = updatedHistory.panelsSnapshot[updatedHistory.index];

    if (panels) {
      dispatch(LOAD_PANELS_FROM_HISTORY(panels, rowSpacing, columnSpacing, metersPerPixel));
    }
  }

  render() {
    const { history } = this.props;

    // hidden before release, will be fixed later

    if (!DEBUG.enablePanelsUndo) {
      return null;
    }
    
    return (
      <Button variant="text" onClick={this.action} className="roofs-selector-button" tooltipLabel="undo" disabled={!history.canUndo}>
        <SVG src={require('assets/media/icons/icon_undo.svg')} />
      </Button>
    );
  }
}

function mapStateToProps(state: appState) {
  return {
    history: state.history,
  };
}

export default connect(mapStateToProps)(Undo);
